<div
  class="flex flex-column gap-3 align-items-center justify-content-center border-round-lg border-bottom-3 border-primary shadow-1 bg-white w-16rem h-16rem cursor-pointer p-3">
  <i class="text-5xl p-4 border-primary border-2 border-circle font-light text-primary {{ icon }}"></i>
  <div class="font-semibold text-center h-2rem">{{ label }}</div>
</div>